<template>
	<div class="v-form-public">
		<div class="form__heading">
			<h2 class="form__title">{{subscriptionsYourDetails}}</h2>
		</div>

		<ul class="form__list">
			<li class="form__item">
				<v-textfield-public 
					:label="usersCompanyName" 
					name="company[company_name]" 
					v-validate="`alpha_num_spaces`">
				</v-textfield-public>
			</li>
			<li class="form__item form__item--no-label">
				<v-radios-public 
					name="title_id"
					:options="usersSex"
					:rules="`required|make_choice`">
				</v-radios-public>
			</li>
			<li class="form__item">
				<v-textfield-public 
					:label="usersFirstName + ' (*)'" 
					name="first_name" 
					v-validate="`required|alpha_spaces_dash`">
				</v-textfield-public>
			</li>
			<li class="form__item">
				<v-textfield-public 
					:label="usersMiddleName" 
					name="middle_name">
				</v-textfield-public>
			</li>
			<li class="form__item">
				<v-textfield-public 
					:label="usersLastName + ' (*)'" 
					name="last_name" 
					v-validate="`required|alpha_spaces_dash`">
				</v-textfield-public>
			</li>
			<li class="form__item">
				<v-textfield-public 
					:label="usersPhoneNumber + ' (*)'" 
					name="phone_number" 
					v-validate="`required|phone_number`">
				</v-textfield-public>
			</li>
			<li class="form__item">
				<v-textfield-public 
					:label="usersEmail + ' (*)'" 
					name="email" 
					v-validate="`required|email`" 
					@blur="checkMail">
				</v-textfield-public>
			</li>
			<li class="form__item" v-if="!!is_user_already_exists">
				<label class="form__label"></label><b style="color: red;">{{userAlreadyExists}}</b>
				<input type="hidden" name="user_already_exists" v-validate="`required`">
			</li>      
			<li v-if="isRecaptcha === 'true'" class="form__item">
				<v-recaptcha @validate="checkRecaptcha" :site-key="recaptchaKey"></v-recaptcha>
			</li>
			<li v-if="buttonAlign == 'left'" class="form__item" style="justify-content: flex-start;">
				<button class="form__button" type="submit" @click.prevent="submitForm">
					{{buttonName}}
				</button>
			</li>
			<li v-else class="form__item" style="justify-content: flex-end;">
				<button class="form__button" type="submit" @click.prevent="submitForm">
					{{buttonName}}
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
import VTextfieldPublic from "./VTextfieldPublic";
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
	inject: ['$validator'],
	components: {
		VTextfieldPublic
	},
	data () {
		return {
			is_user_already_exists: 0,
			recaptchaTicked: false
		}
	},
	computed: {
		...mapGetters(["locales"])
	},
	props: {
		buttonName: {
			default: 'Submit',
			type: String
		},
		buttonAlign: {
			default: 'left',
			type: String
		},
		showSuccess: {
			default: 1,
			type: Number
		},
		successText: {
			default: '',
			type: String
		},
		errorText: {
			default: '',
			type: String
		},
		isRecaptcha: {
			default: 'false',
			type: String
		},
		recaptchaMessage: {
			default: 'Please tick recaptcha',
			type: String
		},
		recaptchaKey: {
			default: '',
			type: String
		},
		subscriptionsYourDetails: {
			default: '',
			type: String
		},
		usersCompanyName: {
			default: '',
			type: String
		},
		usersSex: {
			default: () => {},
			type: Object
		},
		usersFirstName: {
			default: '',
			type: String
		},
		usersMiddleName: {
			default: '',
			type: String
		},
		usersLastName: {
			default: '',
			type: String
		},
		usersPhoneNumber: {
			default: '',
			type: String
		},
		usersEmail: {
			default: '',
			type: String
    },
    usersBankAccount: {
			default: '',
			type: String
    },
    usersBic: {
			default: '',
			type: String
		},
		userAlreadyExists: {
			default: '',
			type: String
		}
	},
	methods: {
		checkMail: function (event) {
			var email = event.target.value;
			if (email == '') return this.is_user_already_exists = 0;
			var vm = this;
			$.ajax({
				url: `/api/users/check-mail`,
				method: 'post',
				data: {
					email:email
				},
				success: function (result) {
					vm.is_user_already_exists = +result;
				},
				error: function () {
				}
			});
		},
		checkRecaptcha: function (result) {
			if (result === false) {
				this.recaptchaTicked = false;
			} else {
				this.recaptchaTicked = true;
			}
		},
		submitForm: function (e) {
			e.preventDefault();
			this.$validator.validateAll().then((res) => {
				if (this.isRecaptcha === 'true') {
					if (!this.recaptchaTicked) {
						sweetalert(window.app.locales.common.error, this.recaptchaMessage, 'error');
						return;
					}
				} 
				if (res) {
					let form = $('#form');
					let data = $('form').serialize();
					var message= this.successText;
					var errorMessage= this.errorText;
					if(this.showSuccess){
						$.ajax({
							url: form.attr('action'),
							method: 'post',
							data: data,
							success: function (result) {
								if(result.url!==undefined){
									if(message!==''){
										sweetalert(window.app.locales.common.success,message, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}else{
										sweetalert(window.app.locales.common.success,window.app.locales.subscriptions.successfully_added, 'success').then((res) => {
											window.location.replace(result.url);
										});
									}
								}
							},
							error: function(result){
								if(result.responseJSON.url!==undefined){
									if(errorMessage!==''){
										sweetalert(window.app.locales.common.error,errorMessage, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}else{
										sweetalert(window.app.locales.common.error,window.app.locales.common.error, 'error').then((res) => {
											window.location.replace(result.responseJSON.url);
										});
									}
								}
							}
						});
					}else{
						form.submit();
					}
				} else {
					sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
				}
			});
		}
	}
}
</script>